import { MruConfigService } from '../../shared/mru/mru-config.service';
import { GraphService } from '../../shared/services/graph.service';
import { OneDriveGraphService } from '../../shared/services/onedrive-graph.service';
import { CapabilitiesService } from '../../shared/shared-context/capabilities.service';
import { ContextService } from '../../shared/shared-context/context.service';
import { SharePointConfigService } from '../../sharepoint/sharepoint-config.service';
import { DiskPreloadMarkerName } from './disk-preload-marker-name.enum';
import { DiskPreloadUrlPatternEntry } from './disk-preload-url-pattern-entry.model';

export function diskPreloadUrlPatternsFactory(
    contextService: ContextService,
    mruConfigService: MruConfigService,
    sharePointConfigService: SharePointConfigService,
    capabilitiesService: CapabilitiesService
): ReadonlyArray<DiskPreloadUrlPatternEntry> {
    if (contextService.sharedContext.inMockMode) {
        return [
            { pattern: new RegExp('/mock/v2/recent/docs', 'i'), markerName: DiskPreloadMarkerName.Mru },
            { pattern: new RegExp('/mock/docs/recent', 'i'), markerName: DiskPreloadMarkerName.Mru },
            { pattern: new RegExp('/mock/sites', 'i'), markerName: DiskPreloadMarkerName.SharePointSites },
            { pattern: new RegExp('/mock/recommended/api', 'i'), markerName: DiskPreloadMarkerName.RecommendedDocuments },
            { pattern: new RegExp('/mock/(.*)/me/drive/root', 'i'), markerName: DiskPreloadMarkerName.OneDriveRoot },
            { pattern: new RegExp('/mock/PeoplePredictionsB2/api', 'i'), markerName: DiskPreloadMarkerName.OfficeFeedDocuments },
            { pattern: new RegExp('/mock/PeoplePredictionsB2/MicrosoftFeed', 'i'), markerName: DiskPreloadMarkerName.OfficeFeedV2Documents }
        ];
    }

    const diskPreloadPatterns = [];
    const edgeworthEnabled = !!capabilitiesService?.capabilities?.edgeworthEnabled;

    if (mruConfigService && mruConfigService.config) {
        const {
            mruServiceRoot,
            substrateApiEndpoint,
            officeFeedApiRootPath,
            recommendedB2ApiFilesPath,
            recommendedB2ApiRootPath
        } = mruConfigService.config;

        if (!edgeworthEnabled) {
            diskPreloadPatterns.push({
                pattern: new RegExp(`^${mruServiceRoot}/v2/recent/docs`, 'i'),
                markerName: DiskPreloadMarkerName.Mru
            });
        }

        diskPreloadPatterns.push({
            pattern: new RegExp(`^${substrateApiEndpoint}/${recommendedB2ApiRootPath}/${recommendedB2ApiFilesPath}`, 'i'),
            markerName: DiskPreloadMarkerName.RecommendedDocumentsV1
        }, {
            pattern: new RegExp(`^${substrateApiEndpoint}/${officeFeedApiRootPath}/(.*)/insights/query\\(context=null,scenario='(.*)',target=null,section='(.*)'\\)`, 'i'),
            markerName: DiskPreloadMarkerName.OfficeFeedDocuments
        }, {
            pattern: new RegExp(`^${substrateApiEndpoint}/PeoplePredictionsB2/MicrosoftFeed\\?section=(.*)&rs=(.*)&forceNewSchema=true`, 'i'),
            markerName: DiskPreloadMarkerName.OfficeFeedV2Documents
        });
    }

    if (!edgeworthEnabled) {
        if (sharePointConfigService && sharePointConfigService.config) {
            diskPreloadPatterns.push({
                pattern: new RegExp(`^${sharePointConfigService.config.sharePointServiceRoot}`, 'i'),
                markerName: DiskPreloadMarkerName.SharePointSites
            });
        }

        if (contextService && contextService.sharedContext) {
            const { graphBeta, graphV1 } = GraphService;
            const graphApiRoot = contextService.sharedContext.graphApiRoot;

            diskPreloadPatterns.push({
                pattern: new RegExp(`^${graphApiRoot}/(${graphBeta}|${graphV1})/${OneDriveGraphService.myDriveEndpoint}root$`, 'i'),
                markerName: DiskPreloadMarkerName.OneDriveRoot
            });
        }
    }

    return diskPreloadPatterns;
}
